"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSpacingSizes = exports.IconColorThemes = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var IconColorThemes;
(function (IconColorThemes) {
    IconColorThemes["uiDark1"] = "uiDark1";
    IconColorThemes["primary"] = "primary";
    IconColorThemes["faded"] = "faded";
})(IconColorThemes = exports.IconColorThemes || (exports.IconColorThemes = {}));
var IconSpacingSizes;
(function (IconSpacingSizes) {
    IconSpacingSizes["default"] = "default";
    IconSpacingSizes["small"] = "small";
    IconSpacingSizes["medium"] = "medium";
    IconSpacingSizes["large"] = "large";
})(IconSpacingSizes = exports.IconSpacingSizes || (exports.IconSpacingSizes = {}));
var SVGElement = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"])), function (props) {
    switch (props.spacing) {
        case IconSpacingSizes.small:
            return '0.4rem';
        case IconSpacingSizes.medium:
            return '0.6rem';
        case IconSpacingSizes.large:
            return '0.8rem';
        default:
            return '0';
    }
});
var Star = function (props) {
    var defaultProps = {
        color: IconColorThemes.primary,
        outlineOnly: false,
        size: b2c_theme_1.defaultIconSize,
        spacing: IconSpacingSizes.default,
    };
    var _a = __assign(__assign({}, defaultProps), props), color = _a.color, outlineOnly = _a.outlineOnly, size = _a.size, spacing = _a.spacing, rest = __rest(_a, ["color", "outlineOnly", "size", "spacing"]);
    var _b = (0, react_1.useState)(b2c_theme_1.colors.defaultIconColor), iconColor = _b[0], setIconColor = _b[1];
    var _c = (0, react_1.useState)(b2c_theme_1.defaultIconSize), iconSize = _c[0], setIconSize = _c[1];
    var _d = (0, react_1.useState)(false), outline = _d[0], setOutline = _d[1];
    (0, react_1.useEffect)(function () {
        switch (color) {
            case IconColorThemes.primary:
                setIconColor(b2c_theme_1.colors.primaryColor);
                break;
            case IconColorThemes.uiDark1:
                setIconColor(b2c_theme_1.colors.iconUiDark1);
                break;
            case IconColorThemes.faded:
                setIconColor(b2c_theme_1.colors.inactiveIconColor);
                break;
            default:
                setIconColor(b2c_theme_1.colors.defaultIconColor);
        }
    }, [color]);
    (0, react_1.useEffect)(function () {
        switch (size) {
            case b2c_theme_1.IconSizes.xSmall:
                setIconSize(b2c_theme_1.IconSizesPx.xSmall);
                break;
            case b2c_theme_1.IconSizes.small:
                setIconSize(b2c_theme_1.IconSizesPx.small);
                break;
            case b2c_theme_1.IconSizes.medium:
                setIconSize(b2c_theme_1.IconSizesPx.medium);
                break;
            case b2c_theme_1.IconSizes.large:
                setIconSize(b2c_theme_1.IconSizesPx.large);
                break;
            case b2c_theme_1.IconSizes.default:
                setIconSize(b2c_theme_1.defaultIconSize);
            default:
                setIconSize(b2c_theme_1.defaultIconSize);
        }
    }, [size]);
    var innerIcon = (0, react_1.useMemo)(function () {
        switch (iconSize) {
            case b2c_theme_1.IconSizesPx.xSmall:
                if (outline) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("g", { clipPath: "url(#clip1_49_1018)" },
                            react_1.default.createElement("path", { "data-testid": "star-icon-path-outline", d: "M6 0.769043L7.7 4.21304L11.5 4.76504L8.75 7.44504L9.399 11.231L6 9.44404L2.601 11.231L3.25 7.44504L0.5 4.76504L4.3 4.21304L6 0.769043Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                        react_1.default.createElement("defs", null,
                            react_1.default.createElement("clipPath", { id: "clip1_49_1018" },
                                react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_1017)" },
                        react_1.default.createElement("g", { clipPath: "url(#clip1_49_1017)" },
                            react_1.default.createElement("path", { "data-testid": "star-icon-path", d: "M6 0.769043L7.7 4.21304L11.5 4.76504L8.75 7.44504L9.399 11.231L6 9.44404L2.601 11.231L3.25 7.44504L0.5 4.76504L4.3 4.21304L6 0.769043Z", fill: iconColor, stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }))),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_1017" },
                            react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })),
                        react_1.default.createElement("clipPath", { id: "clip1_49_1017" },
                            react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.small:
                if (outline) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("g", { clipPath: "url(#clip0_49_1003)" },
                            react_1.default.createElement("g", { clipPath: "url(#clip1_49_1003)" },
                                react_1.default.createElement("path", { "data-testid": "star-icon-path-outline", d: "M9 0.975342L11.6077 6.25834L17.4375 7.10547L13.2188 11.2173L14.2144 17.0246L9 14.283L3.78563 17.0246L4.78125 11.2173L0.5625 7.10547L6.39225 6.25834L9 0.975342Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }))),
                        react_1.default.createElement("defs", null,
                            react_1.default.createElement("clipPath", { id: "clip0_49_1003" },
                                react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })),
                            react_1.default.createElement("clipPath", { id: "clip1_49_1003" },
                                react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_1004)" },
                        react_1.default.createElement("g", { clipPath: "url(#clip1_49_1004)" },
                            react_1.default.createElement("path", { "data-testid": "star-icon-path", d: "M9 0.975342L11.6077 6.25834L17.4375 7.10547L13.2188 11.2173L14.2144 17.0246L9 14.283L3.78562 17.0246L4.78125 11.2173L0.5625 7.10547L6.39225 6.25834L9 0.975342Z", fill: iconColor, stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }))),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_1004" },
                            react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })),
                        react_1.default.createElement("clipPath", { id: "clip1_49_1004" },
                            react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.medium:
                if (outline) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("g", { clipPath: "url(#clip0_49_934)" },
                            react_1.default.createElement("path", { "data-testid": "star-icon-path-outline", d: "M12.0212 2.11353L15.2399 8.63644L22.4378 9.68227L17.2295 14.7594L18.4587 21.9281L12.0212 18.5427L5.58366 21.9281L6.81283 14.7594L1.60449 9.68227L8.80241 8.63644L12.0212 2.11353Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                        react_1.default.createElement("defs", null,
                            react_1.default.createElement("clipPath", { id: "clip0_49_934" },
                                react_1.default.createElement("rect", { width: "24", height: "24", fill: "transparent" })))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_933)" },
                        react_1.default.createElement("path", { "data-testid": "star-icon-path", d: "M12.0212 2.11353L15.2399 8.63644L22.4378 9.68227L17.2295 14.7594L18.4587 21.9281L12.0212 18.5427L5.58366 21.9281L6.81283 14.7594L1.60449 9.68227L8.80241 8.63644L12.0212 2.11353Z", fill: iconColor, stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_933" },
                            react_1.default.createElement("rect", { width: "24", height: "24", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.large:
                if (outline) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("g", { clipPath: "url(#clip0_102_486)" },
                            react_1.default.createElement("path", { "data-testid": "star-icon-path-outline", d: "M32.5 6.34601L40.998 23.565L60 26.326L46.25 39.729L49.496 58.654L32.5 49.719L15.504 58.654L18.75 39.729L5 26.326L24.002 23.565L32.5 6.34601Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                        react_1.default.createElement("defs", null,
                            react_1.default.createElement("clipPath", { id: "clip0_102_486" },
                                react_1.default.createElement("rect", { width: "64", height: "64", fill: "transparent" })))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_102_487)" },
                        react_1.default.createElement("path", { "data-testid": "star-icon-path", d: "M32.5 6.34601L40.998 23.565L60 26.326L46.25 39.729L49.496 58.654L32.5 49.719L15.504 58.654L18.75 39.729L5 26.326L24.002 23.565L32.5 6.34601Z", fill: iconColor, stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_102_487" },
                            react_1.default.createElement("rect", { width: "64", height: "64", fill: "transparent" })))));
        }
    }, [iconSize, iconColor, outline]);
    (0, react_1.useEffect)(function () {
        setOutline(outlineOnly);
    }, [outlineOnly]);
    return (react_1.default.createElement(SVGElement, __assign({ width: iconSize, height: iconSize, viewBox: "0 0 ".concat(iconSize, " ").concat(iconSize), fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "star-icon", spacing: spacing }, rest), innerIcon));
};
exports.default = Star;
var templateObject_1;
//# sourceMappingURL=Star.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Icons/Star/Star.js
// module id = 314
// module chunks = 81